import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

export default class MenuLogin extends WebComponent {
  static defaultProps = {
    bodyClassName: 'login-popup-visible',
    isNotLoggedClassName: 'notLoggedInUserTrigger',
    loginPopupWrapperClassName: 'login-popup-wrapper',
    loginPopupWrapperActiveClassName: 'login-popup-wrapper--active'
  }

  constructor(props) {
    super(props);

    this.state = {
      isOpen: false
    };

    this.objects = {};

    this.handleClick = this.handleClick.bind(this);
  }

  didMount() {
    const {
      isNotLoggedClassName,
      loginPopupWrapperClassName
    } = this.props;

    this.objects.loginPopupWrapperElement = document.querySelector(`.${loginPopupWrapperClassName}`);
    this.objects.parentElement = this.element.parentNode;

    if (this.objects.parentElement.classList.contains(isNotLoggedClassName)) {
      this.on('click', this.handleClick);
    }
  }

  update() {
    const {
      bodyClassName,
      loginPopupWrapperActiveClassName
    } = this.props;

    const {
      isOpen
    } = this.state;

    const {
      loginPopupWrapperElement
    } = this.objects;

    if (isOpen) {
      document.body.classList.add(bodyClassName);
      if (loginPopupWrapperElement) {
        loginPopupWrapperElement.classList.add(loginPopupWrapperActiveClassName);
      }
    } else {
      document.body.classList.remove(bodyClassName);
      if (loginPopupWrapperElement) {
        loginPopupWrapperElement.classList.remove(loginPopupWrapperActiveClassName);
      }
    }
  }

  handleClick(e) {
    const {
      isOpen
    } = this.state;

    e.preventDefault();

    this.setState({
      isOpen: !isOpen
    });
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/MenuLogin.js